import * as React from "react";
import {
  UrlField,
  TextField,
  FunctionField,
  TextInput,
  SelectInput,
  ReferenceInput,
  EditButton,
} from "react-admin";
import { phoneNumberFormat } from "src/common/UtilFunctions";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";

const listFilters = [
  <TextInput source="search" label="Search" alwaysOn />,
  <ReferenceInput
    source="type"
    reference="admin/maker/filters"
    filter={{ type: "type" }}
    required
  >
    <SelectInput
      label="Type"
      optionText={(record) => {
        return record.name;
      }}
    />
  </ReferenceInput>,
  <ReferenceInput
    source="region"
    reference="admin/maker/filters"
    filter={{ type: "region" }}
    required
  >
    <SelectInput
      label="Region"
      optionText={(record) => {
        return record.name;
      }}
    />
  </ReferenceInput>,
];

export const MakerList = (props) => {
  return (
    <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="name" />
        <FunctionField
          label="Phone"
          render={(record) => phoneNumberFormat(record.phone)}
        />
        <UrlField source="website" />
        <FunctionField label="Type" render={(record) => record.type.name} />
        <FunctionField label="Region" render={(record) => record.region.name} />
        <IfCanAccess action="edit">
          <EditButton />
        </IfCanAccess>
      </Datagrid>
    </List>
  );
};
